import React, { useEffect, useState } from 'react'
import {
	updateStatutCommandeForChauffeur,
	getCommande,
} from '../../api/commande'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Modal from 'react-modal'
import AjouterDemandeTransfert from '../DemandeTransfert/AjouterDemandeTransfert'
import ModiferDemandeTransfert from '../DemandeTransfert/ModiferDemandeTransfert'
import { useTranslation } from 'react-i18next'
import UpdateInfoDestinataireModal from "../UpdateInfoDestinataire/UpdateInfoDestinataireModal"
function CourseACourseHorizontal({
	commande,
	onClickDetails = () => { },
	onClickFacture = () => { },
	onClickAvoir = () => { },
	onClickSignaler = () => { },
	onClickHistoriqueChauffeur = () => { },
	hideStatus = false,
	hideAccept = true,
	hideTransfert = true,
	hideSignaler,
	onClickAccept = () => { },
	hideRadio = false,
	hidePrice = false,
	hideRecu = false,
	hideAttribuer = false,
	hideTarif = false,
	hidecancel = false,
	hideUpdate = false,
	hidefacture = false,
	enableSaveStatus = false,
	onClickRecu = () => { },
	onClickRefuser = () => { },
	onClickAttribuer = () => { },
	onClickTransferer = () => { },
	onClickCancel = () => { },
	onClickPayer = () => { },
	setModalIsOpenStatus,
	setModalIsOpenStatusAnnuller,
	setUpdateStatus,
	setModalIsOpenStatusInitTerminer,
	setMessage


}) {
	const [statut, setStatut] = useState(commande.statut)
	const user = useSelector(state => state.auth.user)
	const [modalIsOpenTransfret, setModalIsOpenTransfret] = useState(false)
	const token = useSelector((state) => state.auth.token);
	
	const [modalIsOpenStatusSendSMS, setModalIsOpenStatusSendSMS] = useState(false)
	const [modalIsOpenUpdateTransfret, setModalIsOpenUpdateTransfret] = useState(false)
	const [modalIsOpenUpdateInfo, setModalIsOpenUpdateInfo] = useState(false)
	
	
	
	
	

	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
	const [isTablette, setIsTablette] = useState(() => window.innerWidth <= 1024 && window.innerWidth > 768);

	useEffect(() => {
		const checkScreen = () => {
			const width = window.innerWidth;

			setIsMobile(width <= 768);
			setIsTablette(width > 768 && width <= 1024);
		};
		checkScreen();
		window.addEventListener('resize', checkScreen);

		return () => window.removeEventListener('resize', checkScreen);
	}, []);
	const { t } = useTranslation();
	return (

		<div
			style={{
				width: '100%',
				background: '#E4EAF0',
				display: 'flex',
				flexDirection: isMobile ? 'column' : 'row',
				padding: '1rem',
				borderRadius: 10,
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				marginBottom: 10,
				gap: '10px'
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: isMobile || isTablette ? 'column' : 'row',
					gap: '10px'
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						fontSize: 13,
					}}
				>
					<span
						style={{
							fontWeight: 'bold',
							color: '#51C7F2',
							marginBottom: 3,
						}}
					>
						{t("course_à_course")} {!!commande ? ' N°' + commande.__id : ''} /{' '}
						<span style={{ color: '#1C63C5' }}>
							{commande.temporisation === 'immediat'
								? t("immédiate")
								: t("planifiée")}
						</span>
					</span>

					<span
						style={{
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("transport_date")} :{' '}
						<span
							style={{
								marginRight: 15,
								color: '#838EAB',
								fontWeight: 'bolder'
							}}
						>
							{moment(commande.date_transport).format('DD/MM/YYYY')}
						</span>
					</span>

					<span
						style={{
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("creation_date")} :{' '}
						<span
							style={{
								marginRight: 15,
								color: '#838EAB',
								fontWeight: 'bolder'
							}}
						>
							{moment(commande.createdAt).format('DD/MM/YYYY')}
						</span>
					</span>

					<span
						style={{
							marginRight: 13,
							marginBottom: '1rem',
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,


						}}
					>
						{t("start_date")}  :{'  '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{moment(commande?.courses[0]?.date_debut).isValid() ?
								moment(commande?.courses[0]?.date_debut).format('DD/MM/YYYY')
								: commande?.courses[0]?.date_debut
							}{' '}
							{moment(commande?.courses[0]?.heure_debut).isValid() ?
								moment(commande?.courses[0]?.heure_debut).format('hh:mm')
								: commande?.courses[0]?.heure_debut}
							{' '}
							{commande.courses[0]?.adresse_debut?.label}
						</span>

					</span>

					<span
						style={{
							marginRight: 13,
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("end_date")}  :{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{moment(commande?.courses[0]?.date_fin).isValid() ?
								moment(commande?.courses[0]?.date_fin).format('DD/MM/YYYY')
								: commande?.courses[0]?.date_fin
							}{' '}
							{moment(commande.courses[0]?.heure_fin).isValid() ?
								moment(commande.courses[0]?.heure_fin).format('HH:mm')
								: commande.courses[0]?.heure_fin}
							{' '}
							{commande.courses[0]?.adresse_fin?.label}
						</span>
					</span>


					<span
						style={{
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("payment_status")} :{' '}
						<span
							style={{
								marginRight: 15,
								color: '#838EAB',
								fontWeight: 'bolder'
							}}
						>
							{commande.paymentStatus === 'payé' ? t("paid") : t("unpaid")}

						</span>
					</span>
					<span
						style={{
							color: '#838EAB',
							width: '15rem',
							marginTop: 10,
						}}
					>
						{t("order_status")} :{' '}
						<span
							style={{
								marginRight: 15,
								color: '#838EAB',
								fontWeight: 'bolder'
							}}
						>
							{commande?.statut === "init" && t("not_started")}
							{commande?.statut === "en-cours" && t("in_progress")}
							{commande?.statut === "terminer" && t("completed")}
							{commande?.statut === "annuler" && t("cancelled")}
						</span>
					</span>
					{(!hideTransfert && commande.recu && commande.statut === "en-cours") && (
						<span
							style={{
								color: '#838EAB',
								width: '15rem',
								marginTop: 10,
							}}
						>
							{t("transfer_status")} :{' '}
							<span
								style={{
									marginRight: 15,
									color: '#838EAB',
									fontWeight: 'bolder'
								}}
							>
								{commande?.statutTransfert === 'transferé' && t("transferred")}
								{commande?.statutTransfert === "en cours de transfert" && t("in_transfer")}
								{commande?.statutTransfert === "aucun transfert" && t("no_transfers")}

							</span>
						</span>
					)}
					<span
						style={{
							color: '#838EAB',
							marginTop: 10,
						}}
					>
						<span style={{
							color: '#838EAB',
							fontWeight: 'bolder'
						}}>
							+{commande?.courses?.length >= 1 ? commande.courses.length - 1 : 0} {t("steps")}{' '}
						</span>
						<span
							style={{ cursor: 'pointer' }}
							onClick={onClickDetails}
						>
							{t("view_details")}
						</span>
					</span>
					{/* {user?.role === "client" &&
					<span
						style={{
							color: '#838EAB',
							marginTop: 10,
						}}>
						Affectation:{' '}
						<span style={{
							color: '#838EAB',
							fontWeight: 'bolder'
						}}>
							{!commande.transporterID && 'Non Affecté'}
							{(commande.transporterID && !commande.chauffeurID) && 'Transporteur Affecté'}
							{(commande.chauffeurID && commande.transporterID) && 'Chauffeur Affecté'}
						</span>
					</span>
				} */}
				</div>

				{/*  */}

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						fontSize: 13,
						height: '100%',

					}}
				>
					<span
						style={{
							color: '#838EAB',
							marginBottom: '1rem',

						}}
					>
						{t("number_of_loaders")} :{' '}
						<span style={{
							color: '#838EAB',
							fontWeight: 'bolder'
						}}>
							{commande?.nombre_rippeur || 0}

						</span>
					</span>
					<span
						style={{
							color: '#838EAB',
							marginBottom: '1rem',

						}}
					>
						Documents :{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{
								(commande?.courses
									?.reduce((total, course) => total + (course.files?.length || 0), 0))
							}

						</span>
					</span>
					<span
						style={{
							marginBottom: 3,
							color: '#838EAB',
							marginBottom: '1rem',

						}}
					>
						{t("internal_refrence")} :{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.ref_client}
						</span>
					</span>
					<span
						style={{
							marginBottom: 3,
							color: '#838EAB',
							marginBottom: '1rem',

						}}
					>
						{t("total_km")} :{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.distance}
						</span>
					</span>
					{user?.role === "client" &&
						<span
							style={{
								marginBottom: 3,
								color: '#838EAB',
								marginBottom: '1rem',

							}}
						>
							{t("assignment")} :{' '}
							<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
								{!commande.transporterID && t("unassigned")}
								{(commande.transporterID && !commande.chauffeurID) && t("assigned_transporter")}
								{(commande.transporterID && commande.chauffeurID) && t("assigned_driver")}

							</span>
						</span>

					}



				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						fontSize: 13,
					}}
				>
					{!hideTarif && (<div
						style={{
							background: 'white',

							display: 'flex',
							flexDirection: 'row',
							color: '#838EAB',
							fontSize: 13,
							borderRadius: 5,
							marginBottom: 3,
						}}
					>
						<span
							style={{
								marginRight: 15,
								display: 'flex',
								flexDirection: 'column',
								fontWeight: 'bold',
								fontSize: 14,
								padding: '1rem 0.3rem',
							}}
						>
							<span>
								{t("total_amount")}:{' '}
								<span className='price'>
									{
										user.role === 'client' || user.role === 'commercial' || user.role === 'admin' || user?.role === 'super admin' ?
											(commande.prix).toFixed(2) :
											((commande.prix) - ((commande.prix + (commande.packages || []).reduce((total, p) => total + p.price, 0)) * (commande.margin ?? 0)) / 100).toFixed(2)
									}€
								</span>
							</span>
						</span>
					</div>)}
					{!hideTarif && (<div
						style={{
							background: 'white',

							display: 'flex',
							flexDirection: 'row',
							color: '#838EAB',
							fontSize: 13,
							borderRadius: 5,
							marginBottom: 3,
						}}
					>
						<span
							style={{
								marginRight: 15,
								display: 'flex',
								flexDirection: 'column',
								fontWeight: 'bold',
								fontSize: 14,
								padding: '1rem 0.3rem',
							}}
						>
							<span>
								{t("initial_amount")}:{' '}
								<span className='price'>
									{user.role === 'client' || user.role === 'commercial' || user.role === 'admin' || user.role === "super admin" ? (commande.prix).toFixed(2) : (commande.prix - (commande.prix * (commande.margin ?? 0)) / 100).toFixed(2)}€
								</span>
							</span>
						</span>
					</div>)}

					{!hideTarif && commande.statut === "annuler" && commande.rembourse === true && (
						<div
							style={{
								background: 'white',
								padding: '0.2rem .2rem',
								display: 'flex',
								flexDirection: 'row',
								color: '#838EAB',
								fontSize: 13,
								borderRadius: 5,
								marginBottom: 3,
							}}
						>
							<span
								style={{
									marginRight: 15,
									display: 'flex',
									flexDirection: 'column',
									fontWeight: 'bold',
									fontSize: 14,
									padding: '1rem 0.3rem',
								}}
							>
								<span>
									{t("refunded_amount")}:{' '}
									<span className='price' style={{ color: '#838EAB', fontWeight: 'bolder' }}>
										{((user.role === 'client' || user.role === 'commercial' || user.role === 'admin' || user.role === 'super admin') && commande.statutPrecedent === 'init') ? (
											Number(commande?.prixRembourse).toFixed(2)
										) : (
											((user.role === 'client' || user.role === 'commercial' || user.role === 'admin' || user.role === 'super admin') && commande.statutPrecedent === 'en-cours') && (
												Number(commande?.prixRembourse).toFixed(2)
											)
										)}
										€
									</span>
								</span>

							</span>
						</div>)}


					{!hideStatus &&
						<div
							style={{
								//padding: '0.5rem 2rem',
								display: 'flex',
								flexDirection: 'column',
								color: '#838EAB',
								fontSize: 13,
								borderRadius: 5,
								marginBottom: 3,
							}}
						>
							<span
								onClick={async () => {
									if (enableSaveStatus) {
										try {
											await updateStatutCommandeForChauffeur(
												commande._id,
												'en-cours',
												token
											)
											setStatut('en-cours')
											setUpdateStatus(true)
										} catch (error) {
											setMessage(error.response.data.error)
											setModalIsOpenStatus(true)

										}

									}
								}}
								style={{
									padding: '0.3rem 0.7rem',
									background:
										statut === 'en-cours' ? '#C752B6' : '#838EAB',
									color: statut === 'en-cours' ? 'white' : '#9EA8BF',
									borderRadius: 50,
									fontWeight: 'bold',
									marginBottom: 5,
									fontSize: 10,
									cursor: 'pointer',
									width: '4.5rem',
								}}
							>
								{t("in_progress")}
							</span>

							<span
								onClick={onClickSignaler}
								style={{
									padding: '0.3rem 0.7rem',
									background: commande?.signaler
										? '#FCC200'
										: '#838EAB',
									color: commande?.signaler ? 'white' : '#9EA8BF',
									cursor: 'pointer',
									borderRadius: 50,
									fontWeight: 'bold',
									marginBottom: 5,
									fontSize: 10,
									width: '4.5rem',
								}}
							>
								{t("report")}{' '}
								{commande?.signaler && `+${commande.signalement_count}`}
							</span>

							<span
								onClick={async () => {
									if (enableSaveStatus) {
										const commandeData = await getCommande(commande._id, token)
										let aucunCoursLivre;
										aucunCoursLivre = commandeData?.courses.some(course => course?.livrée === false);

										console.log("aucunCoursLivre", aucunCoursLivre)
										if (commandeData?.statut === "init") {
											setModalIsOpenStatusInitTerminer(true)
										}
										else {
											try {
												await updateStatutCommandeForChauffeur(
													commande._id,
													'terminer',
													token
												)
												setStatut('terminer')
												setUpdateStatus(true)
											} catch (error) {
												setMessage(error.response.data.error)
												setModalIsOpenStatus(true)
											}
										}




									}
								}}
								style={{
									padding: '0.3rem 0.7rem',
									background:
										statut === 'terminer' ? '#0FD39E' : '#838EAB',
									color: statut === 'terminer' ? 'white' : '#9EA8BF',
									borderRadius: 50,
									fontWeight: 'bold',
									marginBottom: 5,
									fontSize: 10,
									cursor: 'pointer',
									width: '4.5rem',
								}}
							>
								{t("complete")}
							</span>
							{/* <span

						style={{
							padding: '0.3rem 0.7rem',
							background:commande?.statut ==="annuler" ?'red' :'#838EAB',
							
							color:commande?.statut ==="annuler"   ? 'white' : '#9EA8BF',
							borderRadius: 50,
							fontWeight: 'bold',
							fontSize: 10,
							cursor: 'pointer',
							width: '4.5rem',
						}}
					>
						Annuler
					</span> */}

						</div>
					}
				</div>

				{/*  */}

				<div
					style={{
						color: '#838EAB',
						display: 'flex',
						flexDirection: 'column',
						fontSize: 13,
					}}
				>
					<span>
						{t("handling_eq1")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.manutention.includes('Diable') && t("yes")}
						</span>
					</span>
					<span>
						{t("handling_eq2")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.manutention.includes('Transpalette manuel') &&
								t("yes")}
						</span>
					</span>
					<span>
						{t("handling_eq3")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.manutention.includes(
								'Transpalette électrique'
							) && t("yes")}
						</span>
					</span>
					<span>
						{t("handling_eq4")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.manutention.includes('Sangle') && t("yes")}
						</span>
					</span>

					<span>
						{t("ppe_eq1")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Casque') && t("yes")}
						</span>
					</span>
					<span>
						{t("ppe_eq2")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Gants') && t("yes")}
						</span>
					</span>
					<span>
						{t("ppe_eq3")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Masque') && t("yes")}
						</span>
					</span>
					<span>
						{t("ppe_eq4")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Lunettes') && t("yes")}
						</span>
					</span>
					<span>
						{t("ppe_eq5")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Chaussure de sécurité') &&
								t("yes")}
						</span>
					</span>
					<span>
						{t("ppe_eq6")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
							{commande.epi.includes('Gilet de visibilité') && t("yes")}
						</span>
					</span>
				</div>
			</div>

			<div>
				<div
					style={{
						//width: '16%',
						display: 'flex',
						flexDirection: 'column',
						fontSize: 13,
						marginTop: 35,
					}}
				>
					{!hideAttribuer && !commande.chauffeurID && (
						<>
							{commande.chauffeurID && (

								<span
									style={{
										color: '#838EAB',
									}}
								>
									{t("driver")} :{' '}
									<span
										style={{
											color: '#838EAB',
											fontWeight: 'bold',
										}}
									>
										{commande.chauffeurID.first_name}{' '}
										{commande.chauffeurID.last_name}
									</span>
								</span>
							)}

							<button
								onClick={onClickAttribuer}
								style={{
									padding: '0.5rem 1.5rem',
									background: '#50F5A9',
									border: 'none',
									cursor: 'pointer',
									color: 'white',
									borderRadius: 7,
									marginTop: 5,
									fontFamily: 'Montserrat',
									fontWeight: 'bold',
								}}
							>
								{t("assign")}
							</button>

						</>
					)}
					{!hideAttribuer && commande.chauffeurID && (
						<>
							{commande.chauffeurID && (
								<span
									style={{
										color: '#838EAB',
									}}
								>
									{t("driver")} :{' '}
									<span
										style={{
											color: '#838EAB',
											fontWeight: 'bold',
										}}
									>
										{commande.chauffeurID.first_name}{' '}
										{commande.chauffeurID.last_name}
									</span>
								</span>
							)}

							<button
								onClick={onClickTransferer}
								style={{
									padding: '0.5rem 1.5rem',
									background: '#50F5A9',
									border: 'none',
									cursor: 'pointer',
									color: 'white',
									borderRadius: 7,
									marginTop: 5,
									fontFamily: 'Montserrat',
									fontWeight: 'bold',
								}}
							>
								{t("transfer")}
							</button>

						</>
					)}
					<button
						onClick={onClickDetails}
						style={{
							padding: '0.5rem 1.5rem',
							background: '#51C7F2',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 5,
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
						}}
					>
						{t("view_details")}
					</button>
					{!hideAttribuer && commande.chauffeurID && (
						<button
							onClick={onClickHistoriqueChauffeur}
							style={{
								padding: '0.5rem 1.5rem',
								background: '#50F5A9',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("view_driver_history")}
						</button>
					)}
					{hideStatus && !hideSignaler &&
						<button
							onClick={onClickSignaler}
							style={{
								padding: '0.5rem 1.5rem',
								background: '#838EAB',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("reports")}
						</button>
					}
					{!hidefacture &&
						<button
							onClick={onClickFacture}
							style={{
								padding: '0.5rem 1.5rem',
								background: '#99ff99',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("view_invoice")}
						</button>
					}
					{!hidefacture && commande.statut === "annuler" && commande.rembourse === true &&
						<button
							onClick={onClickAvoir}
							style={{
								padding: '0.5rem 1.5rem',
								background: '#99ff99',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("view_credit_note")}
						</button>
					}
					{!hidecancel &&
						<button
							onClick={onClickCancel}
							style={{
								padding: '0.5rem 1.5rem',
								background: commande?.statut === "annuler" ? 'red' : '#ff9999',
								border: 'none',
								cursor: 'pointer',
								color: commande?.statut === "annuler" ? 'white' : 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("cancel")}
						</button>
					}
					{(!hidecancel && !user.premium && commande.prix !== 0 && commande.paymentStatus === "non payé") &&
						<button
							onClick={onClickPayer}
							style={{
								padding: '0.5rem 1.5rem',
								background: commande?.statut === "payé" ? '#66ff66' : '#99ff99',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("pay")}
						</button>
					}
					{!hideUpdate &&
						<button
							onClick={() => setModalIsOpenUpdateInfo(true)} 
							style={{
								padding: '0.5rem 1.5rem',
								background: '#5bc0de',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("edit_recipient")}
						</button>
					}
					{!hideRecu && (
						<button
							onClick={onClickRecu}
							style={{
								cursor: 'pointer',
								fontFamily: 'Montserrat',
								background: commande?.recu ? '#FCC200' : '#fce399 ',
								color: 'white',
								border: 'none',
								fontWeight: 'bold',
								padding: '0.5rem 1.5rem',
								borderRadius: 7,
								marginTop: 5,
							}}
						>
							{t("received")}
						</button>

					)}
					{(!hideTransfert && commande.recu && commande.statut === "en-cours") && (
						<button
							onClick={() => {
								if (commande.statutTransfert && commande.statutTransfert === "en cours de transfert") {

									setModalIsOpenUpdateTransfret(true)
								}
								if (commande.statutTransfert && commande.statutTransfert === "aucun transfert") {
									setModalIsOpenTransfret(true)

								}
							}}
							style={{
								cursor: 'pointer',
								fontFamily: 'Montserrat',
								background: '#51C7F2',
								color: 'white',
								border: 'none',
								fontWeight: 'bold',
								padding: '0.5rem 1.5rem',
								borderRadius: 4,
								marginTop: 5,
							}}
						>
							{t("transfer_request")}
						</button>
					)}
					{(!hideRecu && !commande?.recu) && (
						<button
							onClick={onClickRefuser}
							style={{
								cursor: 'pointer',
								fontFamily: 'Montserrat',
								background: '#f29393',
								color: 'white',
								border: 'none',
								fontWeight: 'bold',
								padding: '0.5rem 1.5rem',
								borderRadius: 4,
								marginTop: 5,
							}}
						>
							{t("reject")}
						</button>

					)}

					{!hideAccept && (
						<button
							onClick={onClickAccept}
							disabled={!commande?.canAccept}
							style={{
								cursor: 'pointer',
								fontFamily: 'Montserrat',
								background: commande?.canAccept ? '#50F5A9' : '#838EAB',
								color: commande?.canAccept ? 'white' : '#9EA8BF',
								border: 'none',
								fontWeight: 'bold',
								padding: '0.5rem 1.5rem',
								borderRadius: 4,
								marginTop: 5,
							}}
						>
							{t("accept")}
						</button>
					)}
				</div>
			</div>


			<Modal
				isOpen={modalIsOpenStatusSendSMS}
				onRequestClose={() => { }}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
					},
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						width: '20rem', // Taille réduite
						borderRadius: 19,
					},
				}}
				contentLabel='Example Modal'
			>
				<div
					style={{
						fontFamily: 'Montserrat',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 15,
						textAlign: 'center',
					}}
				>
					<div
						style={{
							marginTop: 20,
						}}
					>
						{t("complete_err")}
					</div>

					<button
						onClick={() => {
							setModalIsOpenStatusSendSMS(false);
						}}
						style={{
							padding: '0.5rem 1rem',
							background: '#50F5A9',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 30,
						}}
					>
						OK
					</button>
				</div>
			</Modal>
			
			<AjouterDemandeTransfert
				modalIsOpenTransfret={modalIsOpenTransfret}
				setModalIsOpenTransfret={setModalIsOpenTransfret}
				commande={commande} />
			{modalIsOpenUpdateTransfret &&
				<ModiferDemandeTransfert
					modalIsOpenUpdateTransfret={modalIsOpenUpdateTransfret}
					setModalIsOpenUpdateTransfret={setModalIsOpenUpdateTransfret}
					commande={commande}
				/>
			}
			<UpdateInfoDestinataireModal 
              modalIsOpenUpdate={modalIsOpenUpdateInfo}
              setModalIsOpenUpdate={setModalIsOpenUpdateInfo}
              commandeId={commande._id}
            />
		</div>
	)
}

export default React.memo(CourseACourseHorizontal)
